import { ReferralAmountTypes } from '@user/store/discountCode/typings'

export function discountAmountString(
  amount: number,
  amountType: ReferralAmountTypes,
) {
  switch (amountType) {
    case ReferralAmountTypes.Flat:
      return `$${amount}`
    case ReferralAmountTypes.Percent:
      return `${amount}%`
  }
}
